/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { CostCentreDto } from '../models/cost-centre-dto';
import { CostCentreDtoDlmBaseResponse } from '../models/cost-centre-dto-dlm-base-response';
import { CostCentreDtoListDlmBaseResponse } from '../models/cost-centre-dto-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class CostCentreService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiCostCentreCostCentresGet
   */
  static readonly ApiCostCentreCostCentresGetPath = '/api/CostCentre/cost-centres';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentreCostCentresGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreCostCentresGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<CostCentreDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentreCostCentresGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CostCentreDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentreCostCentresGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreCostCentresGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<CostCentreDtoListDlmBaseResponse> {

    return this.apiCostCentreCostCentresGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CostCentreDtoListDlmBaseResponse>) => r.body as CostCentreDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentreCostCentresGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreCostCentresGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<CostCentreDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentreCostCentresGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CostCentreDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentreCostCentresGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreCostCentresGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<CostCentreDtoListDlmBaseResponse> {

    return this.apiCostCentreCostCentresGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CostCentreDtoListDlmBaseResponse>) => r.body as CostCentreDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCostCentrePut
   */
  static readonly ApiCostCentrePutPath = '/api/CostCentre';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentrePut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePut$Plain$Response(params?: {
    body?: CostCentreDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentrePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentrePut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePut$Plain(params?: {
    body?: CostCentreDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCostCentrePut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentrePut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePut$Json$Response(params?: {
    body?: CostCentreDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentrePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentrePut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePut$Json(params?: {
    body?: CostCentreDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCostCentrePut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCostCentrePost
   */
  static readonly ApiCostCentrePostPath = '/api/CostCentre';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentrePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePost$Plain$Response(params?: {
    body?: CostCentreDto
  }): Observable<StrictHttpResponse<CostCentreDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentrePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CostCentreDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentrePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePost$Plain(params?: {
    body?: CostCentreDto
  }): Observable<CostCentreDtoDlmBaseResponse> {

    return this.apiCostCentrePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CostCentreDtoDlmBaseResponse>) => r.body as CostCentreDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentrePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePost$Json$Response(params?: {
    body?: CostCentreDto
  }): Observable<StrictHttpResponse<CostCentreDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentrePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CostCentreDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentrePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCostCentrePost$Json(params?: {
    body?: CostCentreDto
  }): Observable<CostCentreDtoDlmBaseResponse> {

    return this.apiCostCentrePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CostCentreDtoDlmBaseResponse>) => r.body as CostCentreDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiCostCentreToggleArchivePost
   */
  static readonly ApiCostCentreToggleArchivePostPath = '/api/CostCentre/toggle-archive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentreToggleArchivePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreToggleArchivePost$Plain$Response(params?: {
    costCentreId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentreToggleArchivePostPath, 'post');
    if (params) {
      rb.query('costCentreId', params.costCentreId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentreToggleArchivePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreToggleArchivePost$Plain(params?: {
    costCentreId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCostCentreToggleArchivePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCostCentreToggleArchivePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreToggleArchivePost$Json$Response(params?: {
    costCentreId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CostCentreService.ApiCostCentreToggleArchivePostPath, 'post');
    if (params) {
      rb.query('costCentreId', params.costCentreId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiCostCentreToggleArchivePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCostCentreToggleArchivePost$Json(params?: {
    costCentreId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiCostCentreToggleArchivePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

}
